import { lazy } from 'react';

export const MedDevicesPage = lazy(() => import('./MedDevicesPage'));
